import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    primary: {
        fontFamily: '"Lato", Arial',
        fontWeight: '400',
    },
    fillImage: {
        maxWidth: '250px',
        maxHeight: '250px'
    },
    card: {
        maxWidth: 250,
    },
    cardContent: {
        backgroundColor: '#f1f1f1'
    },
    media: {
        objectFit: 'cover',
    },
    button: {
        margin: theme.spacing.unit,
        backgroundColor: '#ccc'
    }
});

class Exercise extends Component {
    constructor(props) {
        super(props);

        this.state = {
            image: '../images/totoro/001.gif',
            prevRan: 1,
            imageCap: 'Stretch',
            imageCapArray: ['Stretch', 'Hula Hoop', 'Jump Rope', 'Walking', 'Dhanurasana (Bow Pose)', 'Weights']
        };

        this.handleClick = this.handleClick.bind(this);
    }

    selectImage() {
        var img = '../images/totoro/001.gif';
        var imageCap = 'Stretch';
        var ran = Math.floor(Math.random() * 6) + 1;

        do {
            ran = Math.floor(Math.random() * 6) + 1;
        }
        while (ran === this.state.prevRan);

        img = require('../images/totoro/00' + ran + '.gif');
        imageCap = this.state.imageCapArray[ran - 1];
        this.setState({ image: img, imageCap: imageCap, prevRan: ran });
    }

    handleClick(event) {
        this.selectImage();
    }

    componentDidMount() {
        this.selectImage();
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <h4>Exercise</h4>
                <p>Playful random image of various types of exercise. Each visit ( or reload using the provided button ) will result in a randomly chosen exercise.</p>
                <p>Credit to CL Terry on the images.</p>
                <Card className={classes.card}>
                    <CardMedia
                        component="img"
                        className={classes.media}
                        image={this.state.image}
                    />
                    <CardContent className={classes.cardContent}>
                        <Typography variant="subheading" >
                            <b>{this.state.imageCap}</b>
                        </Typography>
                    </CardContent>
                    <CardActions className={classes.cardContent}>
                        <Button size="small" variant="contained" className={classes.button} onClick={this.handleClick}>
                            Reload
                        </Button>
                    </CardActions>
                </Card>
                <p>&nbsp;</p>
            </div>
        );
    }
}

Exercise.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Exercise);


// WEBPACK FOOTER //
// ./src/components/Exercise.js